import brands from '@/brands/brands.js';

// Marca por defecto cuando el hostname no indique otra cosa
var DEFAULT_BRAND = 'uax';

function getQueryParam(name) {
    var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function isLocalHost(host) {
    return host === 'localhost' || host === '127.0.0.1' || host === '';
}

/**
 * Detecta la marca a partir del hostname:
 *   - portal-grupouax-xtart.*  -> xtart
 *   - portal-grupouax.*        -> uax
 *
 * En local (localhost) se puede forzar con ?brand=xtart|uax, que además queda
 * guardado en localStorage para que se mantenga al navegar por la SPA.
 * En los dominios reales manda SIEMPRE el hostname.
 */
function detectBrand() {
    var host = (window.location.hostname || '').toLowerCase();

    if (isLocalHost(host)) {
        var forced = getQueryParam('brand');
        if (forced) {
            try { window.localStorage.setItem('brand', forced.toLowerCase()); } catch (e) {}
        } else {
            try { forced = window.localStorage.getItem('brand'); } catch (e) {}
        }
        if (forced) {
            return forced.toLowerCase().indexOf('xtart') !== -1 ? 'xtart' : 'uax';
        }
    }

    return host.indexOf('xtart') !== -1 ? 'xtart' : DEFAULT_BRAND;
}

export function brandDetector() {
    var brand = detectBrand();

    // Expone la marca en el <html> para los estilos por marca (src/assets/css/brands.scss)
    document.documentElement.setAttribute('brand', brand);

    // Favicon de la marca
    var faviconEl = document.head.querySelector('[name=favicon]');
    if (faviconEl) {
        faviconEl.href = '/static/favicon/favicon-' + brand + '.ico';
    }

    // Logos de la marca (carpeta static/img/brands/<brand>/)
    var base = '/static/img/brands/' + brand;
    brands.logo = base + '/logo.svg';
    brands.logocolor = base + '/logo-color.svg';
    brands.logoLogin = base + '/logo.svg';
    brands.logoencabezado = base + '/logo.svg';
    brands.logodarkmode = base + '/logo.svg';

    // Tenant que se añade a las urls de AuthUniversidades segun la marca
    brands.tenant = (brand === 'xtart') ? 'XTART' : 'UAXFP';

    return brands;
}



// WEBPACK FOOTER //
// ./src/brands/index.js